<script lang="ts">
  import type { SettlementDetails, BankMatch } from "../types";
  import { formatGbp } from "../../../lib/formatting";
  import Info from "~icons/ph/info-bold";
  import FooterButtons from "../../../components/workflow/FooterButtons.svelte";
  import OfferBreakdown from "../elements/OfferBreakdown.svelte";
  import BankAccountInfo from "../../Settlement/elements/BankAccountInfo.svelte";
  import {
    FaqHowCalculated,
    FaqWhenPayment,
    FaqHowPayment,
    FaqMultipleSettlements,
    FaqWhyFees,
    FaqTaxable,
  } from "../faqs/Faq";
  import DownloadLink from "../../Settlement/elements/DownloadLink.svelte";
  import CloseButton from "../../../components/CloseButton.svelte";

  let {
    settlementDetails,
    bankMatch,
    jlgMainPhone,
    nextSettlementTaskUrl,
  }: {
    settlementDetails: SettlementDetails;
    bankMatch: BankMatch;
    jlgMainPhone: string;
    nextSettlementTaskUrl: string | null;
  } = $props();
</script>

<h2 class="ui-title">Your payment is on its way</h2>

<p>
  We've sent {formatGbp(settlementDetails.payoutAmount)} to your bank account. Funds typically arrive within a few business
  days, depending on your bank. If you don't see it after that, let us know and we'll look into it.
</p>

<OfferBreakdown {settlementDetails} class="mb-6">
  <div class="ui-alert ui-alert-info">
    <Info />
    You accepted the offer, and agreed to the deduction of JLG’s fee of {formatGbp(settlementDetails.jlgFeeAmount)} from your
    compensation as payment.
  </div>
</OfferBreakdown>

<BankAccountInfo {bankMatch} showHeader={true} />

<h3 class="ui-section-title">Have questions?</h3>
<div class="ui-accordion">
  <FaqHowCalculated />
  <FaqWhenPayment />
  <FaqHowPayment phone={jlgMainPhone} />
  <FaqMultipleSettlements />
  <FaqWhyFees gross={settlementDetails.grossSettlementAmount} />
  <FaqTaxable />
</div>

<DownloadLink label="Download statute bill" href={settlementDetails.statuteBillUrl} class="mb-4" />
<DownloadLink label="Download letter of advice" href={settlementDetails.letterOfAdviceUrl} />

<FooterButtons back={false}>
  {#if nextSettlementTaskUrl}
    <CloseButton />
    <a href={nextSettlementTaskUrl} class="btn btn-primary" data-turbo-frame="task-modal">Next settlement</a>
  {:else}
    <CloseButton class="btn-primary w-full" />
  {/if}
</FooterButtons>
